export function formatNumber(num?: number | null): string {
  if (num == null || num === 0) return '-';

  return num.toLocaleString('en-US', {
    useGrouping: true,
    notation: 'compact',
  });
}
